import styled from 'styled-components'
import Icon from '@mdi/react'
import theme from 'theme_'

export const StyledHeaderSorting = styled.div`
  position: relative;
`

export const SortingIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  color: ${theme.colors.horizonOrange};
  position: absolute;
  top: -8px;
  left: 0;
  :hover {
    opacity: 0.8;
  }
`
